import Instruction from "./Instruction";

/**
 * Allow to create a form composed of FormField.
 */
class Form extends Instruction
{
	constructor(submitLabel, fields)
	{
		super();
		this.submitLabel = submitLabel;
		this.fields = fields;
		this.validation = null;
		this.loading = false;
	}
	resolve(variables)
	{
		super.resolve(variables);
		this.fields.forEach((fields) => fields.resolve(variables));
	}
	validateWith(validator)
	{
		this.validation = validator;

		return this;
	}
}

export default Form
